import styled from 'styled-components';

export const StyledSection = styled.div`
  display: flex;
  flex: 1 0;
  padding: ${(p) => p.theme.space[3]} ${(p) => p.theme.space[0]};
  flex-direction: column;

  &:nth-child(odd):not(:last-child) {
    box-shadow: ${(p) => p.theme.shadows.right};
  }

  &:nth-child(1n) {
    grid-column: 1 / 5;
  }

  &:nth-child(2n) {
    grid-column: 5 / 12;
  }

  &:only-child {
    grid-column: 1 / 12;
  }

  @media (max-width: 976px) {
    flex: unset;
    grid-column: unset !important;
  }
`;
